module.exports = __webpack_public_path__ + "img/cn.d1052ca5.svg";